

export const toggleLoading = (isLoading, type) => async dispatch => {
    dispatch({
        type: type,
        payload: isLoading
    })
}